export const emails = EMAIL;
